import React from "react";
import "./UserSettingsModal.css";

function UserSettingsModal({ userInfo, onClose, onEdit }) {
  return (
    <div className="user-settings-modal-overlay">
      <div className="user-settings-modal">
        <h2>ユーザー情報</h2>
        <p><strong>ユーザー名：</strong> {userInfo.user_name}</p>
        <p><strong>メールアドレス：</strong> {userInfo.mail_address}</p>

        <div className="modal-buttons">
          <button onClick={onEdit}>登録情報を編集</button>
          <button onClick={onClose}>閉じる</button>
        </div>
      </div>
    </div>
  );
}

export default UserSettingsModal;